<template>
  <PaginatedList
    :actions="actions"
    :columns="columns"
    :populate="['documents', 'user']"
    :query="query"
    no-results-message="No KYC records to check."
    service="userProfile"/>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/libs'

import PaginatedList from './PaginatedList.vue'

export default {
  name: 'KycFilter',

  components: {
    PaginatedList
  },

  computed: {
    actions () {
      return [{
        click: this.approve,
        text: 'Approve',
        showIf: ({ verifications }) => verifications.identityProvided
      }, {
        click: this.reject,
        text: 'Reject',
        showIf: ({ verifications }) => verifications.identityProvided && !verifications.identityRejected
      }, {
        id: 'user._id',
        text: 'View',
        to: {
          name: 'users.dashboard'
        }
      }]
    },

    columns () {
      return {
        name: {
          header: 'Name',
          format: ({ firstName, lastName }) => `${firstName} ${lastName}`
        },
        'user.email': 'Email',
        'verifications.identityRejected': {
          header: 'Rejected',
          icons: {
            true: 'check',
            false: 'times'
          }
        },
        documents: {
          header: 'Documents',
          format: ({ documents }) => {
            if (this.$_.isArray(documents) && documents.length) {
              let output = '<nav>'

              documents.forEach((document, index) => {
                let href = `${this.base}?bucket=${document.bucket}&uuid=${document.uuid}`

                output += `<a href="${href}">Document ${index + 1}</a>`
              })

              output += '</nav>'

              return output
            }
          }
        }
      }
    },

    filters () {
      return {}
    },

    query () {
      return {
        'verifications.identityProvided::boolean': true,
        'verifications.identityVerified::boolean': false
      }
    },

    ...mapGetters({
      base: 'core/storage/base'
    })
  },

  methods: {
    approve (row) {
      this.toggle(row, true)
    },

    reject (row) {
      this.toggle(row, false)
    },

    async toggle (row, approve) {
      const verifications = this.$_.clone(row.verifications)
      verifications.identityVerified = approve
      verifications.identityVerifiedAt = approve ? this.$moment().format() : ''
      verifications.identityRejected = !approve
      verifications.identityRefectedAt = !approve ? this.$moment().format() : ''

      await this.$store.dispatch('core/user-profile/save', {
        _id: row._id,
        verifications
      })

      this.$flash.success(`User successfully ${approve ? 'approved' : 'rejected'}.`)

      EventBus.$emit('reload-PaginatedList')
    }
  }
}
</script>
